import httpClient from '../httpClient';

const createQuestionType = async (data) => {
  return await httpClient.post(`question_type/`, data);
};

const getQuestionTypes = async () => {
  return await httpClient.get(`question_type/types`);
};

export {
  createQuestionType,
  getQuestionTypes,
}
